import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Tooltip } from 'antd';
import { SelectionToggle } from '../../../custom_shared/components';
import { useAppStore } from '../../stores';
import WorksheetsFilter from './WorksheetsFilter';
import './WorksheetsPanelHeader.less';

const WorksheetsPanelHeader: React.FC = () => {
    const { worksheetsStore, worksheetsSubmissionStore } = useAppStore();

    const hasMultipleWorksheets = worksheetsStore.worksheets.length > 1;
    const { selectiveModeEnabled, setSelectiveModeEnabled } = worksheetsSubmissionStore;

    React.useEffect(() => {
        if (!hasMultipleWorksheets && selectiveModeEnabled) {
            setSelectiveModeEnabled(false);
        }
    }, [hasMultipleWorksheets, selectiveModeEnabled, setSelectiveModeEnabled]);

    return (
        <div className="worksheets-panel-header-container">
            <span className="worksheets-panel-title">Worksheets</span>
            {hasMultipleWorksheets && (
                <div className="worksheets-panel-actions">
                    <WorksheetsFilter />
                    <Tooltip title="Select worksheet" placement="bottom">
                        <span aria-label="Select worksheet">
                            <SelectionToggle
                                enabled={selectiveModeEnabled}
                                onChange={setSelectiveModeEnabled}
                            />
                        </span>
                    </Tooltip>
                </div>
            )}
        </div>
    );
};

export default observer(WorksheetsPanelHeader);
